import type { MessageDescriptor } from "@lingui/core";

import { msg } from "@lingui/core/macro";

import {
  apiGetClinicalStudiesStudyAcronymEnrollPreFill,
  ClinicalStudies,
} from "../../api";
import { resolveEnumLabel } from "../../components/ui-kit/fields/utils";

export async function fetchEnrollmentPrefill(
  studyAcronym: ClinicalStudies,
  enrollmentDate: string,
  patientCountry: string,
) {
  const res = await apiGetClinicalStudiesStudyAcronymEnrollPreFill({
    path: { study_acronym: studyAcronym },
    query: {
      patient_country: patientCountry,
      enrollment_date: enrollmentDate,
    },
  });
  return {
    schedule: res.data.schedule,
    visits: res.data.schedule.map((s) => ({
      visit_date: s.corrected_date ?? s.exact_date,
      visit_type: s.visit_type,
    })),
  };
}

export const StudyVisitType: Record<string, MessageDescriptor> = {
  "pre-screening": msg`Pre-screening`,
  screening: msg`Screening`,
  baseline: msg`Baseline`,
  "follow-up": msg`Follow-up`,
};

export function prettyVisitType(visit: string) {
  if (visit.startsWith("follow-up")) {
    const parts = visit.split("-");
    const followupIndex = parts[parts.length - 1];
    const visitName = parts.slice(0, -1).join("-");
    return `${resolveEnumLabel(StudyVisitType[visitName])} ${followupIndex}`;
  } else {
    return resolveEnumLabel(StudyVisitType[visit]);
  }
}
